module.exports = __webpack_public_path__ + "img/checkmark.6b7994fe.svg";